import { render, staticRenderFns } from "./ReconciliationsListCreate.vue?vue&type=template&id=22f13de5"
import script from "./ReconciliationsListCreate.vue?vue&type=script&lang=js"
export * from "./ReconciliationsListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports